import React from "react"
//import { useLocalization } from "gatsby-theme-i18n"
import { useI18next } from "gatsby-plugin-react-i18next"
import { graphql, useStaticQuery } from "gatsby"

const useFooterMenu = () => {
  //const { locale } = useLocalization()
  const { language: locale } = useI18next()

  const { footer } = useStaticQuery(graphql`
    query FooterMenuThemeQuery {
      footer: allGlobals(filter: { handle: { eq: "footer" } }) {
        nodes {
          locale
          footermenu {
            column {
              __typename
              ...TitleFooterColumnItemFragment
              ...TextFooterColumnItemFragment
              ...LinkFooterColumnItemFragment
            }
          }
        }
      }
    }
  `)

  return React.useMemo(() => {
    return footer.nodes.find(n => n.locale === locale)?.footermenu || null
  }, [footer, locale])
}

export default useFooterMenu

export const footerMenuFragments = graphql`
  fragment TitleFooterColumnItemFragment on TitleFooterColumnItem {
    title
  }

  fragment TextFooterColumnItemFragment on TextFooterColumnItem {
    text
  }

  fragment LinkFooterColumnItemFragment on LinkFooterColumnItem {
    linkType {
      value
    }
    url
    entry {
      url
    }
    isExternal
    openInModal
    linkText
  }
`
